export const sceneConfig = {
  id: 95,
  name: 'blob #xxx - gradient cimetiere', 
  spheres: [
    // {matcapTextureImg: 'assets/textures/dalle-flower/0014.png', perlin: {speed: 0.00008, k: 2.7, mul: 2.4}},
    // {matcapTextureImg: 'assets/textures/unblast/acrylic/1.jpg', perlin: {speed: 0.00027, k: 7.05, mul: 0.6}},
    // {matcapTextureImg: 'assets/textures/freepik-02/0035.jpg', perlin: {speed: 0.00027, k: 2.95, mul: 0.9}},
    {matcapTextureImg: 'assets/textures/unblast/denim/_MD_Training.jpg', perlin: {speed: 0.00027, k: 2.95, mul: 0.9}},
    // {matcapTextureImg: 'assets/textures/unblast/scifi-textures/3.jpg', perlin: {speed: 0.00027, k: 0.55, mul: 0.9}},
    // {matcapTextureImg: 'assets/textures/perso/0009.jpg', perlin: {speed: 0.00027, k: 8.278, mul: 0.278}},
    // {matcapTextureImg: 'assets/textures/perso/0013.jpg', perlin: {speed: 0.00018, k: 1.028, mul: 0.928}},
    // {matcapTextureImg: 'assets/textures/perso/20230326_171027.jpg', perlin: {speed: 0.0001, k: 0.928, mul: 1.228}},
    {matcapTextureImg: 'assets/textures/Photos-001/0050.jpg', perlin: {speed: 0.00027, k: 2.05, mul: 0.9}},
    // {matcapTextureImg: 'assets/textures/Photos-001/0053.jpg', perlin: {speed: 0.00015, k: 2.028, mul: 0.828}},
    // {matcapTextureImg: 'assets/textures/Photos-001/0038.jpg', perlin: {speed: 0.0001, k: 1.928, mul: 0.928}},
  ]
}